export default __webpack_public_path__ + "static/media/audio-quiz.ed7d7c1b.png";